<template>
  <div>
    <div v-if="diagnoses.length">
      <div v-for="(diagnose, index) in diagnoses" :key="index">
        <div v-if="diagnose && diagnose.object" style="padding-top: 10px;">
          <div class="ui raised tall stacked segment">
            {{ diagnose.object.diagnose_text }}
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="ui placeholder segment" style="margin-bottom: 50px">
        <div class="ui icon header" style="color: #092442">
          <i class="dont icon"></i>
          No medical history has been added yet
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    diagnoses: { type: Array, default: () => [] }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/patients/patient_log_componenets/medical_history_components/Diagnoses.vue